import styled from 'styled-components';
import * as breakpoints from '../../common/mediaQueries';
import { ErrorMessage, Field, Form } from 'formik';
import * as colors from '../../common/colorConstants';

const phoneActionPanel = '300px';
const tabletActionPanelWidth = '400px';
const phoneHeaderFontSize = '2.6rem';
const tabletHeaderFontSize = '3.4rem';

export const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding: 0 30px;
`;

export const Title = styled.h1`
  font-size: 5rem;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: 0.03em;
  font-family: 'Questrial', sans-serif;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    font-size: ${tabletHeaderFontSize};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    font-size: ${phoneHeaderFontSize};
  }
`;

export const HighlightText = styled.span`
  display: block;
  color: ${colors.electricBlue};
  font-size: 5rem;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: 0.03em;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    font-size: ${tabletHeaderFontSize};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    font-size: ${phoneHeaderFontSize};
  }
`;

export const Subtitle = styled.p`
  font-family: 'Gilroy', sans-serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.04em;
  text-align: center;
  margin-top: 2rem;
  width: 600px;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    font-size: 1.5rem;
    width: ${tabletActionPanelWidth};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    font-size: 1.4rem;
    color: ${colors.darkGray9};
    width: ${phoneActionPanel};
  }
`;

export const LoginForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoginFormMainElements = styled.div`
  width: 500px;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    width: ${tabletActionPanelWidth};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    width: ${phoneActionPanel};
  }
`;

export const EmailInput = styled(Field)`
  width: 100%;
  display: block;
  height: 60px;
  padding: 2rem;
  margin: 3rem 0 0 0;
  font-size: 2rem;
  border: 1px solid ${colors.dividerColor};
  border-radius: 4px;
`;

export const LoginButton = styled.button`
  margin-top: 3.5rem;
  width: 150px;
  height: 50px;
  padding: 1rem;
  background-color: ${colors.electricBlue};
  color: ${colors.white};
  border: none;
  border-radius: 50px;
  font-size: 2rem;
  cursor: pointer;

  &:hover {
    background-color: ${colors.royalBlue};
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    width: ${tabletActionPanelWidth};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    width: ${phoneActionPanel};
  }
`;

export const FormGroup = styled.div`
  position: relative;
`;

export const Error = styled(ErrorMessage)`
  color: ${(props) => props.color || colors.red};
  font-size: 1.25rem;
  position: absolute;
  bottom: -2.5rem;
  left: 0;
  padding: 0 2rem;
`;

export const GeneralError = styled.div`
  text-align: left;
  color: ${colors.red};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  margin: 3rem 0 0 0;
  background-image: url('/images/error-esclamation.svg');
  background-repeat: no-repeat;
  background-position: center left;
  padding-left: 18px;
  background-size: 12px;
`;
